import { memo } from 'react';

const ProfileInfoTitle = ({ title }: { title: string }) => {
  return (
    <>
      <h4 className="text-primary_black uppercase text-[16px] font-[600] py-4">
        {title}
      </h4>
    </>
  );
};

export default memo(ProfileInfoTitle);
